// Site-wide fixed configuration. Visual identity and integrations are set here
// (and only here) - there are no user-facing controls for these.
export const SITE_CONFIG = {
  theme: 'dark',
  paletteId: 'lime',
  torchVideoId: 'torch-vid5',
  locales: ['en', 'zh', 'es', 'ja'],
  defaultLocale: 'en',
  // Canonical site origin: permanent domain once VITE_SITE_URL is configured,
  // current production deployment until then. Never hardcode the origin elsewhere.
  siteUrl: import.meta.env?.VITE_SITE_URL || 'https://token-landing-rho.vercel.app',
  gettrFiUrl: 'https://gettr.com/finance',
  socialFeedHandle: 'GettrToken',
  tokenMint: 'CatEvkKVmK2fsiVJZ3EzEBuCW8bmNoHKxsXvbBggdebp',
  // Token view page (not a swap link) - "View on Jupiter" framing per approved copy.
  jupiterTokenUrl: 'https://jup.ag/tokens/CatEvkKVmK2fsiVJZ3EzEBuCW8bmNoHKxsXvbBggdebp',
  // Streamflow vesting vault token account holding the locked supply.
  streamflowVault: '47dGuhznRMizGjpFVoCg87ub4EkPKZemFwLq6a37w8MM',
  streamflowVaultUrl: 'https://solscan.io/account/47dGuhznRMizGjpFVoCg87ub4EkPKZemFwLq6a37w8MM',
};
